// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes placeholderLoader{0%{background-position:-500px 0}to{background-position:500px 0}}.article-meta,.article-meta-categories,.article-meta-reading-time{align-items:center;display:flex}.article-meta-categories li+li{margin-left:15px}.article-meta-categories a{font-size:18px;font-weight:800}.article-meta-reading-time{margin-left:22.5px}.article-meta-reading-time span{margin-left:7.5px}.article-meta-reading-time img{margin-top:-5px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
